import type { EnvelopeCatalogResponse, UpdateEnvelopeConfigBody } from '@/lib/api/types';
import type { InvitationTemplate } from './catalog';

/** Resolve stable catalog slugs at use time; never persist environment-specific IDs in templates. */
export function templateEnvelopeConfig(template: InvitationTemplate, catalog: EnvelopeCatalogResponse): UpdateEnvelopeConfigBody {
  const id = (rows: {id: string; slug: string}[], slug: string) => {
    const row = rows.find(item => item.slug === slug);
    if (!row) throw new Error('The matching envelope is unavailable. Please refresh and try again.');
    return row.id;
  };
  return {
    coverId: id(catalog.covers, 'material-felt'),
    flapId: id(catalog.flaps, 'flap-pointed'),
    colorId: id(catalog.colors, template.envelope.colorSlug),
    borderId: id(catalog.borders, 'border-gold'),
    borderColor: '#c9a96e', borderFinish: 'metallic',
    liningId: id(catalog.linings, 'lining-striped-gold'),
    stampId: id(catalog.stamps, 'stamp-none'),
    sealId: id(catalog.seals, 'seal-ampersand-gold'),
    backgroundId: id(catalog.backgrounds, 'bg-parchment'),
    overlayId: id(catalog.overlays, 'overlay-none'),
  };
}
